import { i18n } from "../../init/i18n-setup";
import { v4 as uuidv4 } from "uuid";

import calcWidth from "./helpers";
import { useMjmlStore } from "@/stores/mjmlStore";
import { TopolProductBlock } from "@/schemas/template/blocks/productBlockSchema";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolProductBlock {
    const mjmlStore = useMjmlStore();
    return {
      uid: uuidv4(),
      tagName: "mj-product",
      attributes: {
        "columns-layout": "one-column",
        //image
        image: "*|PRODUCT_IMG_SRC|*",
        "image-width": 300,
        "image-alt": "",
        "image-title": "",
        "image-fluid-on-mobile": "false",
        "image-align": "center",

        //url
        href: "*|PRODUCT_HREF|*",

        //title
        title: `*|PRODUCT_TITLE|*`,
        "raw-title": "*|PRODUCT_TITLE|*",
        "title-font-size": mjmlStore.getStyle("h3", "font-size")
          ? mjmlStore.getStyle("h3", "font-size")
          : "14px",
        "title-color": mjmlStore.getStyle("h3", "color")
          ? mjmlStore.getStyle("h3", "color")
          : "#000000",
        "title-font-family": mjmlStore.getStyle("h3", "font-family")
          ? mjmlStore.getStyle("h3", "font-family")
          : "Helvetica, Arial, sans-serif",
        "title-font-weight": mjmlStore.getStyle("h3", "font-weight")
          ? mjmlStore.getStyle("h3", "font-weight")
          : "normal",
        "title-font-style": mjmlStore.getStyle("h3", "font-style")
          ? mjmlStore.getStyle("h3", "font-style")
          : "normal",
        "title-text-transform": mjmlStore.getStyle("h3", "text-transform")
          ? mjmlStore.getStyle("h3", "text-transform")
          : "none",
        "title-text-decoration": mjmlStore.getStyle("h3", "text-decoration")
          ? mjmlStore.getStyle("h3", "text-decoration")
          : "none",
        "title-align": "center",
        "title-padding": "5px 5px 5px 5px",

        //description
        description: `*|PRODUCT_DESC|*`,
        "raw-description": "*|PRODUCT_DESC|*",
        "description-font-size": mjmlStore.getStyle("p", "font-size")
          ? mjmlStore.getStyle("p", "font-size")
          : "13px",
        "description-color": mjmlStore.getStyle("p", "color")
          ? mjmlStore.getStyle("p", "color")
          : "#000000",
        "description-font-family": mjmlStore.getStyle("p", "font-family")
          ? mjmlStore.getStyle("p", "font-family")
          : "Helvetica, Arial, sans-serif",
        "description-font-weight": mjmlStore.getStyle("p", "font-weight")
          ? mjmlStore.getStyle("p", "font-weight")
          : "normal",
        "description-font-style": mjmlStore.getStyle("p", "font-style")
          ? mjmlStore.getStyle("p", "font-style")
          : "normal",
        "description-text-transform": mjmlStore.getStyle("p", "text-transform")
          ? mjmlStore.getStyle("p", "text-transform")
          : "none",
        "description-text-decoration": mjmlStore.getStyle(
          "p",
          "text-decoration"
        )
          ? mjmlStore.getStyle("p", "text-decoration")
          : "none",
        "description-align": "center",
        "description-padding": "5px 5px 5px 5px",

        //price_before
        "price-before": `*|PRODUCT_PRICE_BEFORE|*`,
        "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
        "price-before-font-size": mjmlStore.getStyle("p", "font-size")
          ? mjmlStore.getStyle("p", "font-size")
          : "13px",
        "price-before-color": mjmlStore.getStyle("p", "color")
          ? mjmlStore.getStyle("p", "color")
          : "#000000",
        "price-before-font-family": mjmlStore.getStyle("p", "font-family")
          ? mjmlStore.getStyle("p", "font-family")
          : "Helvetica, Arial, sans-serif",
        "price-before-font-weight": mjmlStore.getStyle("p", "font-weight")
          ? mjmlStore.getStyle("p", "font-weight")
          : "normal",
        "price-before-font-style": mjmlStore.getStyle("p", "font-style")
          ? mjmlStore.getStyle("p", "font-style")
          : "normal",
        "price-before-text-transform": mjmlStore.getStyle("p", "text-transform")
          ? mjmlStore.getStyle("p", "text-transform")
          : "none",
        "price-before-align": "center",
        "price-before-padding": "5px 5px 5px 5px",

        //price
        price: `*|PRODUCT_PRICE|*`,
        "raw-price": "*|PRODUCT_PRICE|*",
        "price-font-size": mjmlStore.getStyle("h2", "font-size")
          ? mjmlStore.getStyle("h2", "font-size")
          : "18px",
        "price-color": mjmlStore.getStyle("h2", "color")
          ? mjmlStore.getStyle("h2", "color")
          : "#000000",
        "price-font-family": mjmlStore.getStyle("h2", "font-family")
          ? mjmlStore.getStyle("h2", "font-family")
          : "Helvetica, Arial, sans-serif",
        "price-font-weight": mjmlStore.getStyle("h2", "font-weight")
          ? mjmlStore.getStyle("h2", "font-weight")
          : "normal",
        "price-font-style": mjmlStore.getStyle("h2", "font-style")
          ? mjmlStore.getStyle("h2", "font-style")
          : "normal",
        "price-text-transform": mjmlStore.getStyle("h2", "text-transform")
          ? mjmlStore.getStyle("h2", "text-transform")
          : "none",
        "price-text-decoration": mjmlStore.getStyle("h2", "text-decoration")
          ? mjmlStore.getStyle("h2", "text-decoration")
          : "none",
        "price-align": "center",
        "price-padding": "5px 5px 5px 5px",
        "price-suffix": "",
        "price-prefix": "",

        //layout
        layout:
          "image:show,title:show,description:show,priceBefore:show,price:show,button:show",
        dynamic: true,

        //button
        "button-align": "center",
        "button-text-align":
          mjmlStore.getBaseAttrString("mj-button", "text-align") || "center",
        "button-width":
          mjmlStore.getBaseAttrString("mj-button", "width") === "100%"
            ? "100%"
            : "auto",
        "button-border-radius": "3px",
        "button-padding": "5px 5px 5px 5px",
        "button-inner-padding": "10px 25px 10px 25px",
        "button-background-color": mjmlStore.getBaseAttrString(
          "mj-button",
          "background-color"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "background-color")
          : "#e85034",
        "button-color": mjmlStore.getBaseAttrString("mj-button", "color")
          ? mjmlStore.getBaseAttrString("mj-button", "color")
          : "#ffffff",
        "button-font-size": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-size"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-size")
          : "13px",
        "button-font-family": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-family"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-family")
          : "Helvetica, Arial, sans-serif",
        "button-font-weight": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-weight"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-weight")
          : "normal",
        "button-font-style": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-style"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-style")
          : "normal",
        "button-text-transform": mjmlStore.getBaseAttrString(
          "mj-button",
          "text-transform"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "text-transform")
          : "none",
        "button-text-decoration": mjmlStore.getBaseAttrString(
          "mj-button",
          "text-decoration"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "text-decoration")
          : "none",
        button: i18n.global.t("product.more"),

        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
      blockName: "product",
    };
  },
};
